export default "__VITE_ASSET__fa6e09bd__"